export class ControlValueHandler {
  static parseMultiSelectValue(
    value: string,
    isMultiple: boolean,
  ): string | string[] {
    if (!isMultiple) return value;
    return value.includes('|') ? value.split('|') : [value];
  }

  static formatForApi(value: any): string | undefined {
    if (value === null || value === undefined) return undefined;

    if (Array.isArray(value)) {
      return value.length > 0 ? value.join('|') : undefined;
    }

    if (value instanceof Date) {
      return ControlValueHandler.formatDate(value);
    }

    if (typeof value === 'boolean') {
      return value ? 'Y' : 'N';
    }

    return String(value);
  }

  static formatDate(date: Date | string): string {
    if (typeof date === 'string') return date;
    if (!date) return '';

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  static parseValue<T = any>(
    value: any,
    transformFn?: (val: any) => T,
  ): T | null {
    if (!value) return null;
    return transformFn ? transformFn(value) : value;
  }
}
